import { render, staticRenderFns } from "./TaxonomyModal.vue?vue&type=template&id=56856c34&scoped=true&"
import script from "./TaxonomyModal.vue?vue&type=script&lang=js&"
export * from "./TaxonomyModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyModal.vue?vue&type=style&index=0&id=56856c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56856c34",
  null
  
)

export default component.exports